document.addEventListener('DOMContentLoaded', function () {
  // ===== 加购按钮 =====
  document.querySelectorAll('.stv-atc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var handle = this.getAttribute('data-handle');
      var originalText = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;

      fetch('/products/' + handle + '.js')
        .then(function (res) { return res.json(); })
        .then(function (product) {
          var variantId = product.variants[0].id;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          // 更新购物车数量
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              var count = cart.item_count;
              var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
              if (count > 0) {
                if (!bubble) {
                  var iconEl = document.querySelector('#cart-icon-bubble');
                  if (iconEl) {
                    iconEl.insertAdjacentHTML('beforeend', '<div class="cart-count-bubble"><span aria-hidden="true"></span></div>');
                    bubble = iconEl.querySelector('.cart-count-bubble');
                  }
                }
                if (bubble) {
                  var countSpan = bubble.querySelector('span[aria-hidden]');
                  if (countSpan) countSpan.textContent = count > 99 ? '99+' : count;
                  bubble.style.display = '';
                }
              } else if (bubble) {
                bubble.style.display = 'none';
              }
            });

          // 触发 cart:item-added 事件（兼容主题 cart drawer）
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
          var cartDrawer = document.querySelector('cart-drawer, cart-notification');
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();

          btn.textContent = originalText;
          btn.disabled = false;
        })
        .catch(function (err) {
          btn.textContent = originalText;
          btn.disabled = false;
          console.error('Add to cart error:', err);
        });
    });
  });


  // ===== 模块7: Reviews 轮播 =====
  if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
    var $reviews = jQuery('.stv-reviews__slider');

    if ($reviews.length && !$reviews.hasClass('slick-initialized')) {
      $reviews.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0px',
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              centerMode: false,
            }
          }
        ]
      });

      jQuery('.stv-reviews__arrow--prev').on('click', function () {
        $reviews.slick('slickPrev');
      });

      jQuery('.stv-reviews__arrow--next').on('click', function () {
        $reviews.slick('slickNext');
      });
    }
  }


  // ===== 模块6: Specs 轮播 =====
  if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
    var $slider = jQuery('.stv-specs__slider');

    if ($slider.length && !$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
      });

      jQuery('.stv-specs__arrow--prev').on('click', function () {
        $slider.slick('slickPrev');
      });

      jQuery('.stv-specs__arrow--next').on('click', function () {
        $slider.slick('slickNext');
      });
    }
  }

  // ===== 模块8: FAQ 手风琴 =====
  document.querySelectorAll('.stv-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.stv-faq__item');
      var isOpen = item.classList.contains('is-open');

      // 关闭所有
      document.querySelectorAll('.stv-faq__item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });

      // 若原来是关闭的则打开
      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });
});
